import React from "react"

interface TextInputProps {
  required?: boolean;
  label: string;
  type?: React.HTMLInputTypeAttribute;
  fieldName: string;
  value: string | undefined;
  error?: string | undefined;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
}

function TextInput({ required, label, type = 'text', fieldName, value, error, onChange, onBlur }: TextInputProps) {

  return (
    <label>
      {label}{required && <span>*</span>}
      <input type={type} className={error ? 'invalid' : ''} name={fieldName} value={value} onChange={onChange} onBlur={onBlur} />
      {error && <span className="invalid">{error}</span>}
    </label>
  )
}

export default TextInput;
